import { render, staticRenderFns } from "./bidOpening.vue?vue&type=template&id=26b51f1b&"
import script from "./bidOpening.vue?vue&type=script&lang=js&"
export * from "./bidOpening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports